"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRING_MAX_LONG = exports.STRING_MAX = void 0;
exports.STRING_MAX = 100; // Maximum length for most strings
exports.STRING_MAX_LONG = 10000; // For comment fields and similar
